<mat-card *ngFor="let wifiMenu of wifiMenuData.menudata" class="information-program-card">
  <mat-card-header>
    <div mat-card-avatar class="modbus-header-image">
      <mat-icon aria-hidden="false" aria-label="home icon">api</mat-icon>
    </div>
    <mat-card-title>{{wifiMenu.title}}  </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-list>
      <mat-list-item *ngFor="let wifiLine of wifiMenu.items">
        <div mat-line> {{ wifiLine }} </div>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
